import { notification } from "antd";

interface IPropsYmsNotification {
  type: string;
  description: string;
  options?: any;
}

const YmsNotification = ({ type, description, options }: IPropsYmsNotification) => {
  return new Promise((resolve, reject) => {
    try {
      const notificationInstance = notification[type];

      if (typeof notificationInstance !== "function") {
        console.error(`Invalid notification type: ${type}`);
        reject(new Error(`Invalid notification type: ${type}`));
        return;
      }

      notificationInstance({
        description,
        placement: "topRight",
        duration: 1.5,
        className: "notification-class",
        style: {
          whiteSpace: "pre",
          width: "auto",
          display: "inlineBlock",
          wordWrap: "breakWord",
        },
        ...options,
        onClose: () => resolve(true),
      });
    } catch (error) {
      reject(error);
    }
  });
};

export default YmsNotification;
